// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1VvXPg2ltH_xmpJ0JnVY2- {\n    margin-top: 16px;\n    display: flex;\n    justify-content: space-between;\n}\n", ""]);
// Exports
exports.locals = {
	"content": "_1VvXPg2ltH_xmpJ0JnVY2-"
};
module.exports = exports;
